import { useForm } from "react-hook-form"
import { useRecoilValue, useSetRecoilState } from "recoil"
import styled from "styled-components"
import { categoryState, toDoState } from "../../atoms"

const Input = styled.input`
  border: none;
  background-color: #ffcaca67;
  border-radius:0.5rem;
  color:#000000;
  padding: 2em ;
  margin: 0.2rem 0.4rem 0 0.2rem ;
`
const Button = styled.button`
  border: none;
  cursor: pointer;
  background-color:#ff8686;
  border-radius:0.8rem;
  color:white;
  margin:0.1rem;
  padding: 1em ;
`

interface Form {
  toDo: string
}

const CreateTodoElement = () => {
  const setToDos = useSetRecoilState(toDoState)
  const category = useRecoilValue(categoryState)
  const { register, handleSubmit, setValue } = useForm<Form>()
  const handleValid = ({ toDo }: Form) => {
    setToDos((oldToDos) => [
      { text: toDo, id: Date.now(), category },
      ...oldToDos,
    ]);
    setValue("toDo", "");
  }
  return (
    <form onSubmit={handleSubmit(handleValid)}>
      <Input  {...register("toDo", {
        required: "할 일을 입력해주세요",
      })}
        placeholder={category}
      />
      <Button>할 일 추가💡</Button>
    </form>
  )
}

export default CreateTodoElement